import { defu } from 'defu'
import { logout, getToken } from '@/utils/auth'
import type { UseFetchOptions } from 'nuxt/app'

export const useApi = async <T>(url: MaybeRefOrGetter<string>, options: UseFetchOptions<T> = {}) => {
  const config = useRuntimeConfig()
  const accessToken = getToken()

  const defaults: UseFetchOptions<T> = {
    baseURL: config.public.apiBaseUrl as string,
    key: toValue(url) + `data-${Date.now()}`,
    headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
  }

  const params = defu(options, defaults)

  const result = await useFetch(url, params)

  if (result.error.value?.statusCode === 401) {
    logout()
    return Promise.reject(result.error)
  }

  return result
}
